var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 82,
    viewBox: "0 0 62 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8434 55.5H30.7404C20.4157 55.3574 12 46.8248 12 36.5C12 26.0752 20.5788 17.5 31.0012 17.5C41.4236 17.5 50 26.0752 50 36.5V55.5L49.7692 20.003",
    stroke: "url(#paint0_linear_287_970)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 15.5C51.6569 15.5 53 13.933 53 12C53 10.067 51.6569 8.5 50.0001 8.5C48.3431 8.5 47 10.067 47 12C47 13.933 48.3431 15.5 50.0001 15.5Z",
    fill: "#178DFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5001 47.5C37.299 47.5 42 42.799 42 36.9999C42 31.2011 37.299 26.5 31.5001 26.5C25.701 26.5 21 31.2011 21 36.9999C21 42.799 25.701 47.5 31.5001 47.5Z",
    fill: "#178DFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69.2566H52.5581V72.2772C52.5581 73.095 53.0129 73.1136 54 73.03V73.4482C52.7323 73.6341 52.0645 73.3367 52.0645 72.2772V69.2566H51V68.8012H52.0645V67.6394L52.5581 67.5V68.8012H54V69.2566Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7113 73.5C47.1546 73.5 46 72.4176 46 71C46 69.5824 47.1546 68.5 48.7113 68.5C49.7216 68.5 50.5876 68.9789 50.9588 69.7261L50.5361 69.9559C50.2371 69.3525 49.5361 68.9598 48.7113 68.9598C47.4639 68.9598 46.5258 69.8602 46.5258 71C46.5258 72.1398 47.4639 73.0402 48.7113 73.0402C49.5464 73.0402 50.2268 72.6379 50.567 72.0441L51 72.2835C50.5876 73.0211 49.7216 73.5 48.7113 73.5Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5593 68.5C44.0613 68.5 45 69.7069 45 71.0192C45 71.0958 44.9901 71.1724 44.9901 71.249H40.5138C40.6324 72.3314 41.4822 73.0402 42.6087 73.0402C43.419 73.0402 44.0316 72.6762 44.3182 72.1686L44.753 72.4176C44.3478 73.069 43.5771 73.5 42.5988 73.5C41.0771 73.5 40 72.4464 40 71C40 69.592 41.0474 68.5 42.5593 68.5ZM42.5593 68.9598C41.4328 68.9598 40.6126 69.7165 40.5138 70.7797H44.4862C44.3775 69.6111 43.5277 68.9598 42.5593 68.9598Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1655 68.5C38.2908 68.5 39 69.273 39 70.4569V73.5H38.5177V70.4569C38.5177 69.5568 38.0165 68.9697 37.1277 68.9697C36.2009 68.9697 35.4728 69.5959 35.4728 70.9168V73.5H35V68.6076H35.4728V69.5372C35.8322 68.8131 36.4374 68.5 37.1655 68.5Z",
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1655 68.5C33.2908 68.5 34 69.273 34 70.4569V73.5H33.5177V70.4569C33.5177 69.5568 33.0165 68.9697 32.1277 68.9697C31.2009 68.9697 30.4728 69.5959 30.4728 70.9168V73.5H30V68.6076H30.4728V69.5372C30.8322 68.8131 31.4374 68.5 32.1655 68.5Z",
    fill: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5047 73.5C25.1143 73.5 24 72.4176 24 71C24 69.5824 25.1143 68.5 26.5047 68.5C27.8857 68.5 29 69.5824 29 71C29 72.4176 27.8857 73.5 26.5047 73.5ZM26.5047 73.0402C27.6381 73.0402 28.5143 72.1398 28.5143 71C28.5143 69.8602 27.6381 68.9598 26.5047 68.9598C25.3714 68.9598 24.4857 69.8602 24.4857 71C24.4857 72.1398 25.3714 73.0402 26.5047 73.0402Z",
    fill: "#1E1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1691 73.5C19.9237 73.5 19 72.4176 19 71C19 69.5824 19.9237 68.5 21.1691 68.5C21.9773 68.5 22.6701 68.9789 22.967 69.7261L22.6289 69.9559C22.3897 69.3525 21.8289 68.9598 21.1691 68.9598C20.1711 68.9598 19.4206 69.8602 19.4206 71C19.4206 72.1398 20.1711 73.0402 21.1691 73.0402C21.8371 73.0402 22.3814 72.6379 22.6536 72.0441L23 72.2835C22.6701 73.0211 21.9773 73.5 21.1691 73.5Z",
    fill: "#1E1E1E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5593 68.5C17.0613 68.5 18 69.7069 18 71.0192C18 71.0958 17.9901 71.1724 17.9901 71.249H13.5138C13.6324 72.3314 14.4822 73.0402 15.6087 73.0402C16.419 73.0402 17.0316 72.6762 17.3182 72.1686L17.753 72.4176C17.3478 73.069 16.5771 73.5 15.5988 73.5C14.0771 73.5 13 72.4464 13 71C13 69.592 14.0474 68.5 15.5593 68.5ZM15.5593 68.9598C14.4328 68.9598 13.6126 69.7165 13.5138 70.7797H17.4862C17.3775 69.6111 16.5277 68.9598 15.5593 68.9598Z",
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3936 73.5L10.7237 70.63H8.52681V73.5H8V66.5H10.7435C11.8767 66.5 12.8012 67.43 12.8012 68.57C12.8012 69.52 12.155 70.32 11.2704 70.56L13 73.5H12.3936ZM8.52681 67V70.13H10.7435C11.5885 70.13 12.2744 69.43 12.2744 68.57C12.2744 67.7 11.5885 67 10.7435 67H8.52681Z",
    fill: "#1E1E1E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_970",
    x1: 15.4591,
    y1: 20.5511,
    x2: 54.9124,
    y2: 52.0294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#03DCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#04BDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#008BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#178DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9D98FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF65F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed97bbb5a6d651308aab55ab22f7e0ab.svg";
export { ForwardRef as ReactComponent };